module.exports = __webpack_public_path__ + "static/media/M1_ROUGH.0346ae70.png";